import { c as _c } from "react/compiler-runtime";
import { getAvatarUrl } from 'shared/components/header/utils/get-avatar-url';
import { useDashboardUser } from './hooks/use-dashboard-user';
import { usePublicUser } from './hooks/use-public-user';
import { useUserStatus } from './hooks/use-user-status';
const useUser = () => {
  const $ = _c(27);
  const {
    publicUser,
    publicMutate
  } = usePublicUser();
  const {
    dashboardUser,
    dashboardMutate,
    isDisabled
  } = useDashboardUser();
  const user = !isDisabled ? dashboardUser : undefined;
  let t0;
  if ($[0] !== dashboardUser) {
    t0 = getAvatarUrl(dashboardUser);
    $[0] = dashboardUser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const avatarUrl = t0;
  const {
    isWsAdmin,
    checkAdminRoles,
    checkImpersonatorAdminRoles,
    isWorkspaceOwner,
    isAffiliate,
    isCustomer,
    isStudent,
    isWsAssistant,
    isRootAdmin,
    isWhiteLabelOwner,
    isSupportImpersonation,
    isSubAccountImpersonation,
    intlLocale,
    isRestrictedUser,
    isFreemium,
    isPaid
  } = useUserStatus(user);
  const t1 = !dashboardUser && !publicUser;
  let t2;
  if ($[2] !== avatarUrl || $[3] !== checkAdminRoles || $[4] !== checkImpersonatorAdminRoles || $[5] !== dashboardMutate || $[6] !== dashboardUser || $[7] !== intlLocale || $[8] !== isAffiliate || $[9] !== isCustomer || $[10] !== isDisabled || $[11] !== isFreemium || $[12] !== isPaid || $[13] !== isRestrictedUser || $[14] !== isRootAdmin || $[15] !== isStudent || $[16] !== isSubAccountImpersonation || $[17] !== isSupportImpersonation || $[18] !== isWhiteLabelOwner || $[19] !== isWorkspaceOwner || $[20] !== isWsAdmin || $[21] !== isWsAssistant || $[22] !== publicMutate || $[23] !== publicUser || $[24] !== t1 || $[25] !== user) {
    t2 = {
      user,
      publicUser,
      dashboardUser,
      mutate: dashboardMutate,
      mutatePublic: publicMutate,
      isCustomer,
      isAffiliate,
      isStudent,
      checkAdminRoles,
      checkImpersonatorAdminRoles,
      isWorkspaceOwner,
      isWsAdmin,
      isWsAssistant,
      isLoading: t1,
      isDisabled,
      isRootAdmin,
      isWhiteLabelOwner,
      isSubAccountImpersonation,
      isSupportImpersonation,
      intlLocale,
      isRestrictedUser,
      avatarUrl,
      isFreemium,
      isPaid
    };
    $[2] = avatarUrl;
    $[3] = checkAdminRoles;
    $[4] = checkImpersonatorAdminRoles;
    $[5] = dashboardMutate;
    $[6] = dashboardUser;
    $[7] = intlLocale;
    $[8] = isAffiliate;
    $[9] = isCustomer;
    $[10] = isDisabled;
    $[11] = isFreemium;
    $[12] = isPaid;
    $[13] = isRestrictedUser;
    $[14] = isRootAdmin;
    $[15] = isStudent;
    $[16] = isSubAccountImpersonation;
    $[17] = isSupportImpersonation;
    $[18] = isWhiteLabelOwner;
    $[19] = isWorkspaceOwner;
    $[20] = isWsAdmin;
    $[21] = isWsAssistant;
    $[22] = publicMutate;
    $[23] = publicUser;
    $[24] = t1;
    $[25] = user;
    $[26] = t2;
  } else {
    t2 = $[26];
  }
  return t2;
};
export default useUser;